// extracted by mini-css-extract-plugin
module.exports = {"tumor-info-select-wrapper":"TumorInfoSelect_tumor-info-select-wrapper__1_ay7"};